module.exports = __webpack_public_path__ + "img/tp4k.d060297a.png";